import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';

import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import logger from 'redux-logger';

export function configStore (history, preloadedState) {
  const middleware = [thunk, routerMiddleware(history)];

  if (
    !process.env.SKIP_REDUX_LOGGING &&
    ('test' === process.env.NODE_ENV || 'development' === process.env.NODE_ENV)
  ) {
    const testMiddleware = [...middleware, logger];
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    /* eslint-enable */

    return createStore(rootReducer, preloadedState, composeEnhancers(
      applyMiddleware(...testMiddleware)
    ));
  }

  const store = createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(...middleware)
  );

  return store;
}
